import { forwardRef, type InputHTMLAttributes } from 'react';
import { Search } from 'lucide-react';

interface Props extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  /** Visual width of the control (defaults to 256px to match the Figma trades card). */
  width?: number | string;
}

/**
 * Search-styled input matching the trades-card spec:
 *  - `--canvas-inset` track, no border, 8px radius
 *  - leading search icon in `--text-muted`
 *  - 13/16 Inter, placeholder in `--text-subtle`
 *
 * Controlled by the caller (pass `value` + `onChange`).
 */
export const SearchInput = forwardRef<HTMLInputElement, Props>(function SearchInput(
  { width = 256, className = '', style, placeholder = 'Search…', ...rest },
  ref,
) {
  return (
    <div
      className="relative inline-flex items-center"
      style={{ width, ...style }}
    >
      <Search className="pointer-events-none absolute left-3 h-4 w-4 text-text-muted" aria-hidden />
      <input
        ref={ref}
        type="search"
        placeholder={placeholder}
        className={`h-8 w-full rounded-lg border-0 pl-9 pr-3 text-[13px] text-text placeholder:text-text-subtle focus:outline-none focus:ring-2 focus:ring-brand/30 ${className}`}
        style={{ background: 'var(--canvas-inset)' }}
        {...rest}
      />
    </div>
  );
});
